import { render, staticRenderFns } from "./StudentPasswordResetProjection.vue?vue&type=template&id=e6d6b74c"
import script from "./StudentPasswordResetProjection.vue?vue&type=script&lang=js"
export * from "./StudentPasswordResetProjection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports